import React, {
    Component,
    PureComponent
} from 'react'
import {
    Nav,
    NavLink,
    Link,
} from 'react-router-dom'
import { actionTypes } from '../constants';
import moment from 'moment';

import fetch from '../utils/fetch';
import awsconfig from '../awsconfig';

import Icon from '@material-ui/core/Icon';

import EnhancedTable from '../widgets/table-enhanced'
import LinkButton from '../widgets/button-link'
import ChipDetails from '../widgets/chip-details'
import InputClickEditable from '../widgets/input-click-editable'
import DropdownFilterMenu from '../widgets/dropdown-filter-menu';

import ButtonBase from "@material-ui/core/ButtonBase";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import { parseCsv } from '../utils/csv';

const REQUIRED_CSV_FIELDS = [
    'accident_number',
    'date',
    'jurisdiction',
    // 'reporter_id',
    // 'address',
    'vin',
    'drivers_license_id',
    // 'drivers_license_state',
    'insurance_company',
    'insurance_policy_number'
]

import ActionsMenu from './state-data-actions-menu';

class Container extends Component {
    constructor(props) {
        super(props)
        this.state = {
            error: null,
            is_loaded: false,
            csv: null,
        }
        this.uploadRef = null;
    }

    async componentDidMount() {
        this.props.dispatch({type: actionTypes.ACCIDENTS_FETCH_ALL})
        // this.props.dispatch({type: actionTypes.USERS_FETCH_ALL})
        // this.props.dispatch({type: actionTypes.SNACKBAR, snackbar: {severity: 'info', text: 'Lorem ipsum'}})
    }

    async componentDidUpdate(prevProps, prevState){
        console.log(this.state.csv);
        if(this.state.csv && prevState.csv !== this.state.csv){
            try {
                const csvJson = await parseCsv(this.state.csv);
                const headers = Object.keys(csvJson[0]);
                console.log(headers);
                console.log(REQUIRED_CSV_FIELDS);
                REQUIRED_CSV_FIELDS.forEach(key=>{
                    if(headers.indexOf(key) < 0){
                        throw new Error(`Missing CSV column "${key}".`)
                    }
                });
                const accidents = csvJson.map(a=>({
                    ...a,
                    accidentNumber: a.accident_number,
                }));
                console.log(accidents)
                this.props.dispatch({
                    type: actionTypes.ACCIDENTS_CREATE_ONE,
                    data: accidents
                });
            } catch (err) {
                console.error(err);
                this.setState({
                    error: err.message
                })
            }
        }
    }

    render() {
        // if(!this.props.reports.is_loaded || !this.props.users.is_loaded){
        //     return 'Loading...'  // hide while loading
        // }

        console.log(this.props);

        let table = '';
        let accidents = this.props.accidents.list;
        table = <EnhancedTable
            data={accidents.map(a=>{
                return {
                    ...a,
                }
            })}
            order='desc'
            orderBy='createdAt'
            rowsPerPage={10}
            selectable={true}
            selectableKey='_id'
            columns={[
              {id: 'accidentNumber', label: 'Accident #' },
              {id: null, label: 'Coordinates' },
              {id: null, label: 'Reporter' },
              {id: 'createdAt', label: 'Created' },
              {id: null, label: 'Actions'}
            ]}
            buildTableRow={accident=>{
                // prevent r from being mutated when rendering nested copmonent!
                let a = JSON.parse(JSON.stringify(accident));
                return (
                    <React.Fragment>
                        <EnhancedTable.Cell>
                            {a.accidentNumber}
                        </EnhancedTable.Cell>
                        <EnhancedTable.Cell>
                            NULL
                            <br/>
                            (GPS lat/lon)
                        </EnhancedTable.Cell>
                        <EnhancedTable.Cell>
                            NULL
                            <br/>
                            (Foreign Key on CognitoID)
                        </EnhancedTable.Cell>
                        <EnhancedTable.Cell>
                            {moment(a.createdAt).format('MMM Do, YYYY')}
                        </EnhancedTable.Cell>
                        <EnhancedTable.Cell>
                            <ActionsMenu accident={a} dispatch={this.props.dispatch} history={this.props.history} match={this.props.match}/>
                        </EnhancedTable.Cell>
                    </React.Fragment>
                );
            }}
        />

        return (
            <React.Fragment> {/* parent is div.page */}
                <input
                    type="file"
                    accept=".csv"
                    ref={ref=>{this.uploadRef = ref}}
                    onChange={e=>{
                        let file = e.target.files[0];
                        this.setState({
                            csv: file
                        })
                    }}
                    style={{display: 'none'}}
                />
                <div className="page-nav">
                    <div className="breadcrumb">
                        <h1>State Accident Data</h1>
                    </div>
                    <div className="page-actions">
                        <ButtonBase
                            className="button button-primary button-wide"
                            onClick={e=>{
                                console.log('import users')
                                this.uploadRef.value = null;
                                this.setState({
                                    csv: null,
                                    error: null,
                                });
                                this.uploadRef.click();
                            }}
                        >
                            Upload CSV (QA)
                        </ButtonBase>
                    </div>
                </div>
                <div className="card card-table">
                    {this.state.error === null ? null : (
                        <div className="card-content">
                            <div className="error-panel">
                                <div className="error-icon">
                                    <img src={`/dist/assets/img/ic-error.svg`} />
                                </div>
                                <div className="error-message">
                                    {this.state.error}
                                </div>
                            </div>
                        </div>
                    )}
                    {table}
                </div>
            </React.Fragment>
        )
    }
}

import { connect } from 'react-redux'
export default connect(
    (state)=>{
        return {
            accidents: state.accidents,
            // users: state.users,
        }
    },
    (dispatch)=>{
        return {
            dispatch: dispatch
        }
    },
    null,
    {pure: false}
)(Container);